const GlobalAlerts = require('./GlobalAlerts');
const Lang = require('lang');

function BuscaCep() {
  $('[data-busca-cep]').on('change', function () {
    const $formValidator = $(this.form).validate();
    const cep = $(this).cleanVal();

    if (cep != '' && $('#cep_param').valid()) {
      nifty.body.overlay('show');

      $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        delete options.headers['X-CSRF-TOKEN'];
      });

      $.get('//viacep.com.br/ws/' + cep + '/json')
        .done(function (data) {
          if (!('erro' in data)) {
            $('#cidade_param').one('selectize-onload', function () {
              if (data.localidade) {
                this.selectize.setValue(data.localidade);
              }
              data.localidade = null;
            });

            $('#rua_param').val(data.logradouro);
            $('#bairro_param').val(data.bairro);

            const $estadoParam = $('#estado_param') ? $('#estado_param') : null;
            if ($estadoParam !== null) {
              if (!$estadoParam[0].selectize) {
                $('#estado_param').val(data.uf);
              } else {
                $('#estado_param')[0].selectize.setValue(data.uf);
              }
            }
          } else {
            $formValidator.showErrors({
              'cep': Lang.get('js/src/functions/BuscaCep.cep_not_found')
            });
          }
        })
        .fail(function (data) {
          $formValidator.showErrors({
            'cep': Lang.get('js/src/functions/BuscaCep.unexpected_cep_error')
          });
        })
        .always(function (data) {
          nifty.body.overlay('hide');
        });
    }
  });
}

exports.init = BuscaCep;
